module.exports = __webpack_public_path__ + "media/images/cplook/careerplug_white_logo_only-a3e3e84671917efcabcafebd9cce4176.svg";